import { z } from "zod"

export const LinkUnauthorizedParamsSchema = z.object({
  campaignUuid: z.string(),
})
